// extracted by mini-css-extract-plugin
module.exports = {"facebookButton":"Style_facebookButton__31EpN","fLogo":"Style_fLogo__2rqbL","text":"Style_text__3ab-C"};